import MaterialIcon from '@material/react-material-icon';
import BaseSpeedDial, {
	SpeedDialProps,
	SpeedDialActionProps,
} from '../../../../components/UI/SpeedDial/BaseSpeedDial';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

const HtmlLinkInsert = ({
	refElement,
	className,
	handleChange,
	activeElement,
}) => {
	const insertHyperLinkAtCursor = () => {
		const currentIndex = refElement.current.selectionEnd;
		if (currentIndex) {
			const hyperLinkPlaceHolder =
				'<a href=[INSERT URL HERE]>{INSERT DISPLAY TEXT HERE}</a>';
			let firstPart = refElement.current.value.slice(0, currentIndex);
			let secondPart = refElement.current.value.slice(currentIndex);

			refElement.current.value =
				firstPart + hyperLinkPlaceHolder + secondPart;
		}

		//setting the value of the ref element DOES NOT update state and occurs outside of react, call handleChange to update react state appropriately.
		handleChange({
			target: {
				name: refElement.current.name,
				value: refElement.current.value,
			},
		});
	};

	//BaseSpeedDial Implementation start
	const createSpeedDialProps = () => {
		let propResult = new SpeedDialProps();
		propResult.ariaLabel = 'SpeedDial basic example';
		propResult.icon = (
			<>
				Format <KeyboardDoubleArrowRightIcon />
			</>
		);
		propResult.direction = 'right';
		return propResult;
	};

	const createSpeedDialActions = () => {
		let actions = [];

		//html Link Insert
		let linkInsertAction = new SpeedDialActionProps();
		linkInsertAction.icon = (
			<>
				<MaterialIcon icon='link' />
			</>
		);
		linkInsertAction.tooltipTitle = 'Link';
		linkInsertAction.onClick = insertHyperLinkAtCursor;
		actions.push(linkInsertAction);

		return actions;
	};

	return (
		<>
			{activeElement === refElement.current ? (
				<BaseSpeedDial
					speedDialProps={createSpeedDialProps()}
					speedDialActions={createSpeedDialActions()}
				/>
			) : null}
		</>
	);
};

export default HtmlLinkInsert;
